import GeoErrorAlert from './Alert';
import GeoErrorUpateDialog from './UpateDialog';

const GeoErrorComponents = {
  Alert: GeoErrorAlert,
  UpdateDialog: GeoErrorUpateDialog,
};

export default GeoErrorComponents;
